import PropTypes from "prop-types";
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { OTHER_ANSWER, QuestionTypes } from "../../../../../common/constant";
import ObjectUtils, { coalesce, sanitize } from "../../../../../utils/ObjectUtils";
import { findAnswer } from "../../../../../utils/QuestionUtils";
import { getSurveyDateFormat, parseSurveyDate } from "../../../../../utils/SurveyDateUtils";

const {getDeepProperty} = ObjectUtils;

/**
 * Text question component for survey-view.
 */
const SimpleRenderer = ({question, collection, row, column, intl}) => {

    const answer = findAnswer(collection, {row, column});
    const textValue = coalesce(getDeepProperty(answer, "value"), "");
    const type = coalesce(getDeepProperty(column, "type"), question.type, "text").toLowerCase();

    const choices = coalesce(getDeepProperty(column, "choices"), getDeepProperty(question, "choices"), []);

    let value;
    switch (type) {
      case QuestionTypes.text:
      case QuestionTypes.comment:
        value = textValue;
        break;

      case QuestionTypes.number:
        const suffix = coalesce(getDeepProperty(column, "suffix"), question.suffix);
        value = textValue && `${textValue} ${suffix || ""}`;
        break;

      case QuestionTypes.date:
        const date = parseSurveyDate(textValue);
        value = date.isValid() ? date.format(getSurveyDateFormat(question.dateFormat)) : textValue;
        break;

      case QuestionTypes.checkbox:
        const answers = [
          ...choices.map((choice) => findAnswer(collection, { row, column, value: choice.value })),
          findAnswer(collection, { row, column, name: OTHER_ANSWER })
        ];
        value = answers
          .filter((a) => !!a)
          .map((a) => (a.name === OTHER_ANSWER ? a.value : a.text))
          .join(", ");
        break;

      case QuestionTypes.radio:
      case QuestionTypes.dropdown:
      case QuestionTypes.predefinedList.toLowerCase():
        if (answer && answer.name === OTHER_ANSWER) {
          value = textValue;
        } else {
          const option = choices.find((c) => c.value === textValue);

          if (option) {
            value = option.text;
          } else {
            if (answer && answer.text) {
              value = answer.text;
            } else {
              value = textValue;
            }
          }
        }

        break;

      default:
        value = textValue;
        break;
    }

    if (!value) {
        const cleanValue = sanitize(column.required ? intl.formatMessage({ id: "user.surveyView.table.cell.empty" }) : "-")

        return (
          <p
            dangerouslySetInnerHTML={cleanValue}
            className={`${column.required ? "text-danger" : ""}`}
          />
        );
    }

    const cleanValue = sanitize(value);
    return (
      <OverlayTrigger
          placement="top"
          overlay={(
              <Tooltip
                  id="tooltip"
                  className="survey-tooltip"
              >
                  {cleanValue.__html}
              </Tooltip>
          )}
      >
          <p dangerouslySetInnerHTML={cleanValue}/>
      </OverlayTrigger>
    );
};

SimpleRenderer.propTypes = {
    question: PropTypes.object.isRequired,
    collection: PropTypes.array,
    row: PropTypes.object,
    column: PropTypes.object,
};

export default React.memo(SimpleRenderer);
